import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, FileText, MessageCircle, User } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useIsMobile, mobileNavHidden, openChat } from "../../hooks/useIsMobile";

const ITEMS = [
  { key: "home", label: "Home", to: "/", Icon: Home, match: (p) => p === "/" },
  { key: "shop", label: "Shop", to: "/shop", Icon: LayoutGrid, match: (p) => p.startsWith("/shop") },
  { key: "quote", label: "Quote", to: "/quote", Icon: FileText, match: (p) => p.startsWith("/quote") },
  { key: "chat", label: "Chat", Icon: MessageCircle, action: openChat },
  { key: "account", label: "Account", Icon: User, match: (p) => p.startsWith("/dashboard") || p.startsWith("/login") },
];

export function MobileBottomNav() {
  const isMobile = useIsMobile();
  const { pathname } = useLocation();
  const { user } = useAuth();
  if (!isMobile || mobileNavHidden(pathname)) return null;

  return (
    <nav
      aria-label="Mobile navigation"
      className="fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-nav"
    >
      <ul className="grid grid-cols-5 h-16">
        {ITEMS.map(({ key, label, to, Icon, match, action }) => {
          const href = key === "account" ? (user ? "/dashboard" : "/login") : to;
          const active = match ? match(pathname) : false;
          const cls = `flex flex-col items-center justify-center gap-1 h-full font-mono text-[9px] tracking-[0.18em] uppercase font-bold transition-colors ${
            active ? "text-kolt-orange" : "text-kolt-slate-dark/70 active:text-kolt-orange"
          }`;
          return (
            <li key={key} className="relative">
              {active && <span className="absolute top-0 left-4 right-4 h-0.5 bg-kolt-orange" />}
              {action ? (
                <button type="button" onClick={action} className={`${cls} w-full`} data-testid={`mobile-nav-${key}`}>
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                  {label}
                </button>
              ) : (
                <Link to={href} className={cls} data-testid={`mobile-nav-${key}`}>
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
